import axios from "axios";
import LocalStorage from "../../localStorage";
import {loggedOut} from "../auth";

export const GET_LABEL_REQUEST = 'GET_LABEL_REQUEST';
export const GET_LABEL_SUCCESS = 'GET_LABEL_SUCCESS';
export const GET_LABEL_FAILURE = 'GET_LABEL_FAILURE';

const localStorageService = LocalStorage.getService();

export const getLabelRequest = () => {
    return {type: GET_LABEL_REQUEST}
};

export const getLabelSuccess = (label = {}) => {
    return {type: GET_LABEL_SUCCESS, label}
};

export const getLabelFailure = (error) => {
    return {type: GET_LABEL_FAILURE, error}
};

export const startGetLabel = () => {
    console.log('Start startGetLabel');
    let token = localStorageService.getAccessToken();
    return (dispatch) => {
        dispatch(getLabelRequest());
        return axios({
                url: `${process.env.REACT_APP_API_ROOTURL}/label/list?key=${process.env.REACT_APP_SERVICE_ACCOUNT_KEY}`,
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': '*',
                    Authorization: 'Bearer ' + token,
                },
                data: JSON.stringify({}),
            }
        )
            .then(function (response) {
                if (response.status === 200 && response.data !== null) {
                    console.log("Response label search ", response.data);
                    dispatch(getLabelSuccess(response.data));

                }
            })
            .catch(function (error) {
                console.log(error);
                if(error.response.status === 401) dispatch(loggedOut());
                dispatch(getLabelFailure(error));
            });
    };
};
